import { Injectable } from '@angular/core';
import { Company } from '../models/company.model';

/**
 * ContractorService
 */
@Injectable({
	providedIn: 'root'
})
export class ContractorService {
	private _linkedPartnerWithContractor: { [key: string]: Company[] };

	constructor() {}

	get linkedPartnerWithContractor(): { [key: string]: Company[] } {
		return this._linkedPartnerWithContractor;
	}

	set linkedPartnerWithContractor(value: { [key: string]: Company[] }) {
		this._linkedPartnerWithContractor = value;
	}
}
